import * as React from "react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import FieldDisplayEngine from "../../../components/FieldDisplayEngine";
import { getWorkkardDetailMasterData } from "../actions/action";
import { fetchSessionContextOidcRequest } from "../../../common/reducers/sessionContextOidc";
import { RenderEngineKey } from "../constants";
import { selectSessionContextOidc } from "@container/AdminPanel/features/users/usersSelectors";

const EXCLUDE_FROM_DETAILS = [RenderEngineKey.PropertyLocation, RenderEngineKey.CustomerName, RenderEngineKey.AdjusterName];

const PrintWorkkardDetail = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const workkard = useSelector((state) => state.workkardDetail.workkardDetail);
    const sessionContext = useSelector(selectSessionContextOidc);

    const cId = new URLSearchParams(location.search).get("cId");
    const [isPrinting, setIsPrinting] = useState(false);

    useEffect(() => {
        const showButton = () => setIsPrinting(false);
        const hideButton = () => setIsPrinting(true);
        window.addEventListener("beforeprint", hideButton);
        window.addEventListener("afterprint", showButton);
        return () => {
            window.removeEventListener("beforeprint", hideButton);
            window.removeEventListener("afterprint", showButton);
        };
    }, []);

    useEffect(() => {
        // Header normally kicks this off; this route intentionally renders outside
        // Header (no app chrome), so getWorkkardDetailMasterData's saga would otherwise
        // block forever waiting for it.
        dispatch(fetchSessionContextOidcRequest());
    }, []);

    useEffect(() => {
        if (cId) {
            dispatch(getWorkkardDetailMasterData({ cId }));
        }
    }, [cId]);

    useEffect(() => {
        if (workkard && workkard.Id) {
            const timer = setTimeout(() => window.print(), 200);
            return () => clearTimeout(timer);
        }
    }, [workkard && workkard.Id]);

    if (!workkard || !workkard.Id) {
        return null;
    }

    return (
        <div className="modalBody">
            <div className="workkard_print_ctr">
            <div className="workkard_header_information colFlex alignMiddle">
                <span className="">{workkard.WorkkardNumber}</span>
                <div>{workkard.SponsorName}</div>
            </div>
            <div className="workkard_details">
                <div className="header_detail">
                    <div className="claimant_information">


                        <div className="">
                            <div className="workkardMainInfo mt">
                                <div className="wkMainInfo mb">
                                    <div className="cardDefaultInfo colFlex flexGrow">
                                        <div>{workkard.WorkkardTitle}</div>
                                        <div className="alignMiddle">
                                            <span className="mr">{workkard.WorkkardNumber}</span>
                                            <span className={`mr ${(workkard.WorkkardStatusForDisplay || "").toLowerCase()}`}>{workkard.WorkkardStatusForDisplay}</span>
                                        </div>
                                        <ul className="rowFlex wrapFlex">
                                            <FieldDisplayEngine
                                                userTimezone={sessionContext.TimeZoneTz}
                                                tzData={sessionContext.tzData}
                                                data={workkard.CustomFields}
                                                renderLocation="detail"
                                                renderType="workkard"
                                                includeFields={[RenderEngineKey.CustomerName]}
                                            />
                                        </ul>
                                    </div>
                                    <div className="colFlex propertyLocation mb__12">
                                        <ul className="rowFlex wrapFlex">
                                            <FieldDisplayEngine
                                                userTimezone={sessionContext.TimeZoneTz}
                                                tzData={sessionContext.tzData}
                                                data={workkard.CustomFields}
                                                renderLocation="detail"
                                                renderType="workkard"
                                                includeFields={[RenderEngineKey.PropertyLocation]}
                                            />
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div className="wkDetailInfo InlineEditBlock wth-12">
                                <label className="mb__8 mt">Workkard Owner</label>
                                <div>{workkard.SponsorName}</div>
                            </div>
                        </div>

                        <div className="">
                            <label className="mb__8 mt">Details</label>
                            <ul className="rowFlex wrapFlex">
                                <FieldDisplayEngine
                                    userTimezone={sessionContext.TimeZoneTz}
                                    tzData={sessionContext.tzData}
                                    data={workkard.CustomFields}
                                    renderLocation="detail"
                                    renderType="workkard"
                                    excludeFields={EXCLUDE_FROM_DETAILS}
                                    showLabel={true}
                                />
                            </ul>
                        </div>
                        <div className="">
                            <div className="wkDescription">
                                <label className="mb__8 mt">Description</label>
                                <p dangerouslySetInnerHTML={{ __html: workkard.WorkkardSummaryFull || "-" }}></p>
                            </div>

                            <div className="copyright_ftr db">
                                © {new Date().getFullYear()} Exzeo USA, Inc. <a href="/agreement" target="_blank" rel="noopener noreferrer">User Contract</a>
                                <a href="/privacypolicy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
                            </div>

                            {!isPrinting && (
                                <button
                                    type="button"
                                    className="btn-cc__primary"
                                    style={{ position: "fixed", bottom: "24px", left: "50%", transform: "translateX(-50%)" }}
                                    onClick={() => window.print()}
                                >
                                    Print
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
    );
};

export default PrintWorkkardDetail;
